<h2 mat-dialog-title>BIMSWARM ist aktuell nicht verfügbar</h2>
<mat-dialog-content>
    BIMSWARM ist aktuell nicht verfügbar. Bitte versuchen Sie es später nochmal
</mat-dialog-content>